module.exports = __webpack_public_path__ + "img/riskpro-logo.908815e7.svg";